
// Tipos de eventos suportados pelo Facebook Pixel
export type MetaEventType = 
  | 'PageView'
  | 'Lead'
  | 'CompleteRegistration'
  | 'Contact'
  | 'Schedule'
  | 'StartTrial'
  | 'SubmitApplication'
  | 'ViewContent'
  | 'AddToCart'
  | 'InitiateCheckout'
  | 'Purchase';

// Interface para parâmetros de evento 
export interface EventParams {
  [key: string]: string | number | boolean | Date | undefined;
}

// Configurações do Meta
const META_ACCESS_TOKEN = 'EAAFn5OZBIasEBO8VR4YJXZAZCoqNAj6VOiMPQnhxgUO41esphRzMn9LgFNnmrqKZAs9XqcueQpwnSmjjZASVxlxQo68PN9y9V5Qpk3wY4LDGNa4gAiZATCZC4vMClDwtDKPy2SFonIfy7dK7tTXHZBHVCuzV24ePAigXa9MGsHccMYu0ZBhChiJ0oBGvQxeUPZC1sQTAZDZD';
const PIXEL_ID = '850596020599773';

// Função para gerar um ID externo único para deduplicação de eventos
export const generateExternalId = (): string => {
  return `${Date.now()}.${Math.random().toString(36).substring(2, 15)}`;
};

// Função principal para disparo de eventos
export const trackMetaEvent = async (
  eventName: MetaEventType,
  params: EventParams = {},
  options: { serverOnly?: boolean; pixelOnly?: boolean } = {}
): Promise<void> => {
  const eventId = generateExternalId();
  
  // Adicionar event_id para deduplicação
  const eventParams = {
    ...params,
    event_id: eventId,
  };

  // Envio pelo Pixel (cliente)
  if (!options.serverOnly && typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, eventParams);
    console.log(`[Meta Pixel] Event tracked: ${eventName}`, eventParams);
  }

  // Envio pela Conversions API (servidor)
  if (!options.pixelOnly) {
    try {
      // Em um cenário ideal, isso seria feito no backend para proteger seu token de acesso
      // Aqui vamos simular o envio para a Conversions API
      await sendToConversionsAPI(eventName, eventParams);
    } catch (error) {
      console.error('[Meta Conversions API] Error sending event:', error);
    }
  }
};

// Simulação da função que envia para a Conversions API
// Em produção, isso deve ser implementado no backend
const sendToConversionsAPI = async (
  eventName: MetaEventType,
  params: Record<string, any>
): Promise<void> => {
  const endpoint = `https://graph.facebook.com/v18.0/${PIXEL_ID}/events`;
  
  const data = {
    data: [{
      event_name: eventName,
      event_time: Math.floor(Date.now() / 1000),
      event_id: params.event_id,
      event_source_url: window.location.href,
      action_source: 'website',
      user_data: {
        client_ip_address: null, // Será preenchido pelo servidor
        client_user_agent: navigator.userAgent,
      },
      custom_data: params,
    }],
    access_token: META_ACCESS_TOKEN,
  };

  console.log('[Meta Conversions API] Would send event:', {
    endpoint,
    data: JSON.stringify(data, null, 2),
  });
  
  // Em produção, você deve enviar isso através do seu backend
  // para proteger seu token de acesso
  /*
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  
  if (!response.ok) {
    throw new Error(`Failed to send event to Conversions API: ${response.statusText}`);
  }
  */
};
